<div class="header" data-testid="base_dialog_header">
  <h4 class="header-text" data-testid="base_dialog_title">
    {{ title }}
  </h4>

  <button
    class="close"
    type="button"
    puButton
    uiType="quaternary"
    size="s"
    data-testid="base_dialog_close"
    [onlyIcon]="true"
    (click)="dialogRef.close()">
    <pu-icon iconName="close" />
  </button>
</div>

<div class="body" data-testid="base_dialog_body" cdkScrollable>
  <section class="section">
    <ng-container *ngComponentOutlet="component" />
  </section>
</div>
